import { GetCall, PostCall , DeleteCall, PutCall, PatchCall } from './_serviceHelper2'
import { UrlWsUsuarios } from '../config/Services'
import { getTenantInfo, saveTenantInfo } from '../config/Storage'
import { getToken } from '../config/Sesion'

const serviceUrl = UrlWsUsuarios()

/** @returns {JSON} {errores, data} */
export const listarUsuarios = (filters) => GetCall(serviceUrl, filters)

/** @param {String} texto nombre o apellido @returns {JSON} {errores, data} */
export const autocompUsuario = (texto) => GetCall(serviceUrl + '/autocompletar', { texto, activo: true })

/** @param {JSON} unUsuario @returns {JSON} {errores, data} */
export const agregarUsuario = (unUsuario) => PostCall(serviceUrl, unUsuario)

/** @param {JSON} unUsuario @returns {JSON} {errores, data} */
export const modificarUsuario = (unUsuario) => PutCall(serviceUrl, unUsuario)

/** @param {Array} unUsuario @returns {JSON} {errores, data} */
export const borrarUsuarios = (ids) => DeleteCall(serviceUrl, { ids })

/** @param {Array} unUsuario @returns {JSON} {errores, data} */
export const reactivarUsuarios = (ids) => PatchCall(serviceUrl, { ids })
export const cambiarPass = (email, pass, nuevoPass) => PutCall(serviceUrl + '/pass', {email, pass, nuevoPass})
export const recuperarCuenta = (email) => PatchCall(serviceUrl + '/pass', {email})

/********* CONTROL DE SESIONES *********/

/**
 * Busca los tenants disponibles para el usuario según el email y
 * lo cachea en localStorage. Si está desactualizada o si no
 * existe le deja una marca para luego actualizarla al consultar
 * los datos.
 * 
 * @param {String} email del usuario a autenticar.
 * @returns {JSON} ids de los tenants disponibles. Ej.: {errores: ['ERR_MENSAJE'], data: [{id: 1}]}
 */
export const listarTenantsDisponibles = async (email) => {
    const res = await GetCall(serviceUrl+'/tenants', {email})
    if (res.errores) return res
    res.data.forEach(unTenant => {
        //reviso cada tenant y si no tiene info o si está desactualizada, lo actualizo
        let infoGuardada = getTenantInfo(unTenant.id)
        if (!infoGuardada)
            infoGuardada = { ...unTenant, actualizarLogo: true, actualizarDatos: true }
        if (+infoGuardada.versionLogo < +unTenant.versionLogo) {
            infoGuardada.actualizarLogo = true
            infoGuardada.actualizarDatos = true
        }
        saveTenantInfo(infoGuardada)
    })
    return {data: res.data.map(t => ({id: t.id}))}
}

/**
 * Revisa primero en caché si hace falta actualizar algún logo de tenant.
 * En caso de que se necesite, invoca a la API para obtener los logos
 * 
 * @param {String} email del usuario a autenticar.
 * @param {Array<Number>} listaTenantIds de los que se quieren obtener los logos.
 * @returns El logo de cada tenant. Ej: {data:[{id:1, logo:'wej...'},...], errores: ['...']}
 */
export const listarLogos = async (email, listaTenantIds) => {
    //levanto caché y reviso si hay logos que actualizar
    let res = {data: []}
    let idsParaActualizar = []
    listaTenantIds.forEach(id => {
        let infoGuardada = getTenantInfo(id)
        res.data.push({id, logo: infoGuardada.logo})
        if (infoGuardada.actualizarLogo)
            idsParaActualizar.push(id)
    })
    if (idsParaActualizar.length > 0) {
        const resServ = await GetCall(serviceUrl+'/logos', {email, t: idsParaActualizar})
        if (resServ.errores) return resServ
        //actualizo caché
        resServ.data.forEach(unLogo => {
            let infoGuardada = getTenantInfo(unLogo.id)
            infoGuardada.logo = unLogo.logo
            infoGuardada.versionLogo = unLogo.versionLogo
            infoGuardada.actualizarLogo = false
            saveTenantInfo(infoGuardada)
            res.data.find(e => e.id === unLogo.id).logo = unLogo.logo
        })
    }
    return res
}

/**
 * Devuelve los datos del tenant actual. Si la caché tiene datos desactualizados los actualizo.
 * @returns datos del tenant actual.
 */
export const buscarInfoDeTenant = async () => {
    let tenantActual = getTenantInfo(+getToken().ten)
    if (tenantActual?.actualizarDatos) {
        const res = await GetCall(serviceUrl+'/tenants/info')
        if (res.errores) return res
        tenantActual = {...tenantActual, ...res.data, actualizarDatos: false}
        saveTenantInfo(tenantActual)
    }
    return tenantActual
}

export const login = (email, pass, tenantId) => PostCall(serviceUrl+'/sesion', {usuario: {email, pass}, t: tenantId})
export const logout = () => DeleteCall(serviceUrl+'/sesion')

/********* CONSULTAS DE TENANTS *********/
export const listarModulosDeTenant = () => GetCall(serviceUrl+'/tenants/modulos')

/********* CONSULTAS DE ROLES *********/
export const listarRoles = (filters) => GetCall(serviceUrl+'/roles', filters)